module.exports = __webpack_public_path__ + "img/logo_jsyh.fff38329.png";